import {GameAccountTypeResource} from "../resource/GameAccountTypeResource";
import {GameAccountType} from "../league/GameAccountType";
import {IApiGameAccountType} from "../typings/apiResponse";

export class GameAccountTypeService {

    public static $inject = ["GameAccountTypeResource"];
    constructor(private GameAccountTypeResource: GameAccountTypeResource) {}

    public getIdProvider(gameAccountType: string): angular.IPromise<GameAccountType> {
        return this.GameAccountTypeResource.getIdProvider(gameAccountType)
            .then((gameAccountType: IApiGameAccountType) => new GameAccountType(gameAccountType));
    }
}
